var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('icon-circle',{staticClass:"icon base"}),_c('icon-circle',{ref:"icon",staticClass:"icon progress"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }